<main class="main vh-100">
  <section class="auth-login h-100">
    <div class="auth-login-grid">

      <!-- STAGE: dark showroom panel -->
      <div class="auth-stage d-none d-md-flex">
        <div class="auth-stage-glow"></div>

        <!-- NEW: sweeping spotlight -->
        <!-- <div class="auth-stage-spotlight"></div> -->

        <!-- NEW: floating particles -->
        <div class="auth-stage-particles" aria-hidden="true">
          <span></span><span></span><span></span><span></span><span></span><span></span>
        </div>

        <span class="auth-stage-rail">ADMIN ACCESS</span>

        <div class="auth-stage-live">
          <span class="auth-stage-liveDot"></span>
          System online
        </div>

        <div class="auth-stage-car">
          <img src="../../../assets/img/car.png" class="auth-stage-carImg" alt="Featured lot" />
        </div>

        <div class="auth-stage-copy">
          <span class="auth-stage-eyebrow">Marketplace Auction &amp; Exchange</span>
          <h1 class="auth-stage-heading auth-stage-heading--shimmer">
            Every auction runs<br />through here.
          </h1>
          <p class="auth-stage-sub">
            Sign in to manage auctions, users, bidders and purchase records.
          </p>
        </div>

        <div class="auth-stage-ticker">
          <span>№ 12 AUCTIONS LIVE</span>
          <span>№ 48 NEW BIDDERS TODAY</span>
          <span>№ 7 PURCHASES PENDING</span>
        </div>
      </div>

      <!-- TICKET: paper registration panel (now the second grid column) -->
      <div class="auth-ticket auth-ticket--enter">
        <div class="auth-ticket-perf" aria-hidden="true"></div>

        <div class="auth-ticket-inner">
          <div class="auth-ticket-header">
            <a href="javascript:void(0)" class="auction-logo">
              <img src="/assets/img/auction_system_logo.png" alt="Marketplace Auction & Exchange"
                class="auction-logo-img" />
            </a>
          </div>

          <form method="POST" class="auth-login-form credential mt-5" [formGroup]="recoverPassForm" (submit)="submit()">
            <h2 class="auth-ticket-title">Reset Password</h2>
            <p class="auth-ticket-subtitle">
              Enter your new password and confirm it to reset your password
            </p>


            <div class="form-group">
              <label class="credential__floatLabel" for="email">New Password</label>
              <input type="password" class="form-control credential__input transparent" name="password"
                formControlName="password" placeholder="New password" />

              <!-- <div class="errors" *ngIf="formData.email.invalid && submitted">
                <ng-container *ngIf="formData.email.errors?.required">Email is required.</ng-container>
                <ng-container *ngIf="formData.email.errors?.email">Please enter a valid email.</ng-container>
              </div> -->
            </div>
            <div class="form-group">
              <label class="credential__floatLabel" for="email">Confirm Password</label>
              <input type="password" class="form-control credential__input transparent" name="confirmPassword"
                formControlName="confirmPassword" placeholder="Re-enter new password" />

              <!-- <div class="errors" *ngIf="formData.email.invalid && submitted">
                <ng-container *ngIf="formData.email.errors?.required">Email is required.</ng-container>
                <ng-container *ngIf="formData.email.errors?.email">Please enter a valid email.</ng-container>
              </div> -->
            </div>

            <div class="auth-form-btnGrp mb-3">
              <button type="submit" data-style="slide-left" class="btn btn__main fs-normal w-100">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>

    </div>
  </section>
</main>